var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GalleryDashboardCardUI',{attrs:{"event-name":_vm.eventName,"event-date":_vm.eventDate,"images":_vm.images,"all-images-count":_vm.allImagesCount,"user-image-src":_vm.userImageSrc,"user-name":_vm.userName,"post-date":_vm.postDate,"show-level-icon":_vm.showLevelIcon,"gallery-url":_vm.galleryUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }